import { fetchWithAuth } from "../utils/fetchWithAuth";

export const printerService = {
  // Pobieranie listy drukarek z NestHub
  getDiscoveredPrinters: async (hubUuid) => {
    const response = await fetchWithAuth(
      `${process.env.REACT_APP_BACKEND_URL}/api/devices/nesthub/${hubUuid}/printers/`
    );
    
    if (!response.ok) {
      throw new Error('Błąd podczas pobierania drukarek');
    }
    
    const data = await response.json();
    
    // Przekształć dane drukarek z formatu obiektu na format tablicy
    if (data && data.printers) {
      // Konwersja obiektu na tablicę obiektów
      return {
        ...data,
        printersArray: Object.entries(data.printers).map(([serial, printer]) => ({
          id: serial,
          serialNumber: serial,
          ...printer
        }))
      };
    }
    
    // W przypadku braku drukarek zwróć pusty obiekt z pustą tablicą
    return {
      printers: {},
      printersArray: [],
      status: data?.status || "success"
    };
  }
};